import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '../layout/layout';

/**
 * ProtectedRoute component that checks if user is authenticated
 * Redirects to login if not authenticated
 * Can optionally require specific roles
 * Wraps children with Layout to include navbar and footer
 */
const ProtectedRoute = ({ children, requireRole = null }) => {
  const userState = useSelector(state => state.user);
  const isAuthenticated = userState?.user !== null && userState?.user !== undefined;
  const switchedAccount = userState?.switchedAccount;
  
  // Use switched account user if in switch mode, otherwise use original user
  const effectiveUser = switchedAccount ? switchedAccount.studentData?.userId : userState?.user;
  const originalUser = userState?.user;

  // Check if user is authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // If a specific role is required, check if user has that role
  if (requireRole) {
    // For certain routes (admin, parent/business management), always check original role
    const routesRequiringOriginalRole = ['ADMIN', 'PARENT', 'BUSINESS'];
    const requiresOriginalRole = Array.isArray(requireRole)
      ? requireRole.some(role => routesRequiringOriginalRole.includes(role))
      : routesRequiringOriginalRole.includes(requireRole);
    
    const userToCheck = requiresOriginalRole ? originalUser : effectiveUser;
    const userRoles = userToCheck?.roles || [];
    const hasRequiredRole = Array.isArray(requireRole)
      ? requireRole.some(role => userRoles.includes(role))
      : userRoles.includes(requireRole);

    if (!hasRequiredRole) {
      // Redirect to home if user doesn't have required role
      return <Navigate to="/" replace />;
    }
  }

  return <Layout>{children}</Layout>;
};

export default ProtectedRoute;

